import Api from '@/services/Api'

export default {
    getComparativoTrimestral(fecha){
        return Api().get('reportes/getComparativoTrimestral/'+fecha)
    },
    getComparativoTrimestralPorContract(fecha,contrato){
        return Api().get('reportes/getComparativoTrimestralByContract/'+fecha+'/'+contrato)
    },
    getActivosPorContract(lstContratos){
        return Api().get('reportes/getActivosPorContratos/'+lstContratos)
    },
    getActivosPorArrendad(lstArrendadores){
        return Api().get('reportes/getActivosPorArrendador/'+lstArrendadores)
    },
    generaReportePorTercero(fecha){
        return Api().get('reportes/getReportePorTercero/'+fecha)
    },
    generaReportePorContrato(fecha){
        return Api().get('reportes/getReportePorContrato/'+fecha)
    },
    generaReportePorTipoActivo(fecha){
        return Api().get('reportes/getReportePorTipoActivo/'+fecha)
    },
    generaReportePorTipoContrato(fecha){
        return Api().get('reportes/getReportePorTipoContrato/'+fecha)
    },
    generaReporteSaldosPorCierre(fecha){
        return Api().get('reportes/getReporteSaldosPorCierre/'+fecha)
    },
    generaReportSaldosPorContratFechaDesdHasta(fechaDes,fechaHas){
        return Api().get('reportes/getReporteSaldosPorContrDesdHast/'+fechaDes+'/'+fechaHas)
    }
}